import { render } from "./AccountVerificationDataTable.vue?vue&type=template&id=2232e08a&scoped=true"
import script from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"
export * from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"

import "./AccountVerificationDataTable.vue?vue&type=style&index=0&id=2232e08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2232e08a"]])

export default __exports__